import { Button, Form, Input } from "antd";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { useCheckOTP, useSendOtp } from "../../hooks/Authentication/auth.hooks";
import { InputRequired } from "../../validations/validations";
import { OTPFormType, OTPFormValues } from "./data";
import styles from "./styles.module.scss";
const OTPForm: React.FC<OTPFormType> = ({ onFinishCallback }) => {
  const COOLDOWN_SEC = 60;
  let cooldownNumber: number | undefined;
  let cooldownInterval: NodeJS.Timeout;

  const { t } = useTranslation();
  const [form] = Form.useForm();
  const [cooldown, setCooldown] = useState<number | undefined>(undefined);

  const { mutate: sendOTP } = useSendOtp();
  const { mutate: checkOTP } = useCheckOTP();

  const [loadingSendOTP, setLoadingSendOTP] = useState<boolean>(false);
  const [loadingCheckOTP, setLoadingCheckOTP] = useState<boolean>(false);
  const [otpAlreadySent, setOTPAlreadySent] = useState<boolean>(false);

  const initCoolDown = () => {
    setCooldown(COOLDOWN_SEC);
    cooldownNumber = COOLDOWN_SEC;
    cooldownInterval = setInterval(() => {
      setCooldown((cooldownNumber || 1) - 1);
      cooldownNumber = (cooldownNumber || 1) - 1;
      if (cooldownNumber <= 0) {
        setCooldown(undefined);
        cooldownNumber = undefined;
        clearInterval(cooldownInterval);
      }
    }, 1000);
  };

  const handleSendOTP = async () => {
    const value = form.getFieldsValue();
    if (!value.account) {
      form.validateFields(["account"]);
      return;
    }
    setLoadingSendOTP(true);
    await sendOTP(
      { params: { account: value.account } },
      {
        onSuccess: (success: any) => {
          setLoadingSendOTP(false);
          initCoolDown();
          setOTPAlreadySent(true);
          console.debug("success", success);
        },
        onError: (error: any) => {
          setLoadingSendOTP(false);
          form.setFields([
            {
              name: "account",
              errors: [
                t([
                  `error.${error.data.result.code}`,
                  error.data.result.message,
                ]),
              ],
            },
          ]);
          // CustomMessage({
          //   content: t([
          //     `error.${error.data.result.code}`,
          //     error.data.result.message,
          //   ]),
          // });
          console.debug("error", error);
        },
      }
    );
  };

  const onFinish = async (values: OTPFormValues) => {
    setLoadingCheckOTP(true);
    await checkOTP(
      { params: values },
      {
        onSuccess: (success: any) => {
          console.debug("success", success);
          setLoadingCheckOTP(false);
          onFinishCallback(values.account, values.otp);
        },
        onError: (error: any) => {
          console.debug("error", error);
          setLoadingCheckOTP(false);

          form.setFields([
            {
              name: "otp",
              errors: [
                t([
                  `error.${error.data.result.code}`,
                  error.data.result.message,
                ]),
              ],
            },
          ]);
        },
      }
    );
  };

  const renderSendOTPButtonText = () => {
    if (cooldown) return t("auth.button.otpsent", { second: cooldown });
    if (otpAlreadySent) return t("auth.button.resendotp");
    else return t("auth.button.sendotp");
  };

  return (
    <Form
      className={styles.container}
      autoComplete={"off"}
      onFinish={onFinish}
      form={form}
      requiredMark={false}
      layout={"vertical"}
    >
      <Form.Item
        name={"account"}
        label={t("auth.input.registeredemail")}
        rules={[InputRequired(t, "auth.input.registeredemail")]}
      >
        <Input placeholder={t("auth.hint.registeredemail")} />
      </Form.Item>
      <div className={styles.otpInputWrapper}>
        <Form.Item
          name={"otp"}
          className={styles.otpInput}
          rules={[InputRequired(t, "auth.otp")]}
        >
          <Input placeholder={t("auth.hint.otp")} />
        </Form.Item>
        <Button
          className={styles.requestOtpButton}
          type="link"
          size="small"
          loading={loadingSendOTP}
          onClick={handleSendOTP}
          disabled={cooldown !== undefined}
        >
          {renderSendOTPButtonText()}
        </Button>
      </div>
      <Button
        type={"primary"}
        htmlType={"submit"}
        block
        loading={loadingCheckOTP}
      >
        {t("normal.nextstep")}
      </Button>
    </Form>
  );
};

export default OTPForm;
